/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid, Grid } from "frontend/src/components/Layout"
import { CMSLink } from "frontend/src/components/CMSLink"
import { useState } from "react"
import { GrFormClose } from "react-icons/gr"

function VideoTextCtaDesktop({ title, text, buttonText, thumbnailURL, playButtonURL, videoURL }) {
  const [isOpen, setOpen] = useState(false)
  const toggleOpen = () => {
    setOpen(!isOpen)
  }
  return (
    <Grid columns="1fr 1fr" gap="20px" sx={{ display: ["none", "none", "grid"] }}>
      <div
        sx={{
          width: ["122.5vw", "490px", "40.73125vw", "490px"],
          height: ["72.75vw", "291px", "24.189375vw", "291px"],
          mx: 0,
        }}
      >
        {isOpen ? (
          <VideoModal videoURL={videoURL} title={title} toggleOpen={toggleOpen} />
        ) : (
          <div
            sx={{
              width: "100%",
              height: "100%",
              backgroundImage: `url(${thumbnailURL})`,
              backgroundRepeat: "repeat",
              backgroundColor: "rgb(240, 243, 245)",
              backgroundPosition: "50% 50%",
              backgroundSize: "cover",
              borderRadius: "0.75rem",
              opacity: 0.72,
              display: "flex",
              zIndex: 20,
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src={playButtonURL}
              alt="play"
              sx={{
                width: ["20.5vw", "82px", "6.81625vw", "82px"],
                height: ["20.5vw", "82px", "6.81625vw", "82px"],
                zIndex: 2,
              }}
              onClick={toggleOpen}
            />
          </div>
        )}
      </div>
      <div sx={{ py: ["10vw", "40px", "3.325vw", "40px"] }}>
        <h2
          sx={{
            color: "background",
            fontFamily: "body",
            fontSize: ["7.4304vw", "29.7216px", "2.470608vw", "29.7216px"],
            lineHeight: ["9vw", "36px", "2.9925vw", "36px"],
            fontWeight: 500,
            mb: 4,
          }}
        >
          {title}
        </h2>
        <p
          sx={{
            color: "background",
            fontFamily: "body",
            fontWeight: 400,
            fontSize: ["3.9628vw", "15.8512px", "1.317631vw", "15.8512px"],
            lineHeight: ["6.5vw", "26px", "2.16125vw", "26px"],
            width: ["70vw", "280px", "23.275vw", "280px"],
          }}
        >
          {text}
        </p>
        <CMSLink
          link={{
            externalUrl: "#angebot",
            newtab: false,
            follow: false,
            event: "anchorClick",
            destination: "offerSection",
            pageType: "LandingPage",
            section: "video",
          }}
          sx={{
            backgroundColor: "background",
            color: "almostBlack",
            display: "inline-block",
            mt: 4,
            fontFamily: "body",
            fontWeight: 700,
            textAlign: "center",
            width: ["61.75vw", "247px", "20.531875vw", "247px"],
            borderRadius: "41px",
            height: ["9.5vw", "38px", "3.15875vw", "38px"],
            lineHeight: ["9.5vw", "38px", "3.15875vw", "38px"],
            fontSize: ["4.9536vw", "19.8144px", "1.647072vw", "19.8144px"],
          }}
        >
          {buttonText}
        </CMSLink>
      </div>
    </Grid>
  )
}

function VideoTextCtaMobile({
  title,
  text,
  buttonText,
  thumbnailURL,
  playButtonURL,
  isOpen,
  toggleOpen,
  videoURL,
}) {
  return (
    <div
      sx={{
        display: ["block", "block", "none"],
      }}
    >
      <h2
        sx={{
          color: "background",
          fontSize: ["7.4304vw", "29.7216px", "2.470608vw", "29.7216px"],
          lineHeight: ["9vw", "36px", "2.9925vw", "36px"],
          fontFamily: "body",
          fontWeight: 500,
          mb: 4,
          textAlign: "center",
        }}
      >
        {title}
      </h2>
      {isOpen ? (
        <VideoModal videoURL={videoURL} title={title} toggleOpen={toggleOpen} />
      ) : (
        <div
          sx={{
            backgroundImage: `url(${thumbnailURL})`,
            backgroundRepeat: "repeat",
            backgroundColor: "rgb(240, 243, 245)",
            backgroundPosition: "50% 50%",
            backgroundSize: "cover",
            borderRadius: "0.75rem",
            opacity: 0.72,
            width: ["90vw", "360px", "29.925vw", "360px"],
            height: ["89.75vw", "359px", "29.841875vw", "359px"],
            mx: "auto",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            maxWidth: "400px",
          }}
        >
          <img
            src={playButtonURL}
            alt="play"
            sx={{
              width: ["20.5vw", "82px", "6.81625vw", "82px"],
              height: ["20.5vw", "82px", "6.81625vw", "82px"],
            }}
            onClick={toggleOpen}
          />
        </div>
      )}
      <p
        sx={{
          color: "background",
          fontSize: ["3.9628vw", "15.8512px", "1.317631vw", "15.8512px"],
          lineHeight: ["6.5vw", "26px", "2.16125vw", "26px"],
          width: ["70vw", "280px", "23.275vw", "280px"],
          fontFamily: "body",
          fontWeight: 400,
          textAlign: "center",
          mx: "auto",
          mt: 5,
        }}
      >
        {text}
      </p>
      <div sx={{ textAlign: "center" }}>
        <CMSLink
          link={{
            externalUrl: "#angebot",
            newtab: false,
            follow: false,
            event: "anchorClick",
            destination: "offerSection",
            section: "video",
            pageType: "LandingPage",
          }}
          sx={{
            backgroundColor: "background",
            color: "almostBlack",
            display: "inline-block",
            mt: 4,
            fontFamily: "body",
            fontWeight: 700,
            textAlign: "center",
            width: ["61.75vw", "247px", "20.531875vw", "247px"],
            borderRadius: "41px",
            height: ["9.5vw", "38px", "3.15875vw", "38px"],
            lineHeight: ["9.5vw", "38px", "3.15875vw", "38px"],
            fontSize: ["4.9536vw", "19.8144px", "1.647072vw", "19.8144px"],
            mx: "auto",
          }}
        >
          {buttonText}
        </CMSLink>
      </div>
    </div>
  )
}

function IFrame({ videoURL, title }) {
  return (
    <iframe
      width="100%"
      height="100%"
      src={videoURL}
      frameborder="0"
      allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
      title={title}
      allowfullscreen
    ></iframe>
  )
}

function CloseButton({ toggleOpen }) {
  return (
    <div
      sx={{
        width: "24px",
        height: "25px",
        borderRadius: "12px",
        backgroundColor: "white",
        color: "black",
        position: "absolute",
        top: "-12px",
        right: "-12px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      onClick={toggleOpen}
    >
      <GrFormClose sx={{ zIndex: 5 }} />
    </div>
  )
}

function VideoModal({ videoURL, title, toggleOpen }) {
  return (
    <div>
      <div
        sx={{ width: "90vw", height: "89.75vw", display: ["block", "none"], position: "relative" }}
      >
        <IFrame videoURL={videoURL} title={title} />
        <CloseButton toggleOpen={toggleOpen} />
      </div>
      <div
        sx={{
          width: "100%",
          height: "50vh",
          display: ["none", "block", "none"],
          position: "absolute",
          textAlign: "center",
          mx: "auto",
          zIndex: 20,
        }}
      >
        <IFrame videoURL={videoURL} title={title} />
        <CloseButton toggleOpen={toggleOpen} />
      </div>
      <div
        sx={{
          width: "100%",
          height: "50vh",
          display: ["none", "none", "block", "none"],
          position: "absolute",
          textAlign: "center",
          mx: "auto",
          zIndex: 20,
        }}
      >
        <IFrame videoURL={videoURL} title={title} />
        <CloseButton toggleOpen={toggleOpen} />
      </div>
      <div
        sx={{
          width: "100%",
          height: "50vh",
          display: ["none", "none", "none", "block"],
          position: "absolute",
          zIndex: 20,
        }}
      >
        <IFrame videoURL={videoURL} title={title} />
        <CloseButton toggleOpen={toggleOpen} />
      </div>
    </div>
  )
}

function VideoTextCta({ title, text, buttonText, thumbnailURL, playButtonURL, videoURL }) {
  const [isOpen, setOpen] = useState(false)
  const toggleOpen = () => {
    setOpen(!isOpen)
  }
  return (
    <SectionGrid sx={{ backgroundColor: "almostBlack", py: "25px", my: "0" }}>
      <SectionGrid.narrow>
        <VideoTextCtaDesktop
          title={title}
          text={text}
          buttonText={buttonText}
          thumbnailURL={thumbnailURL}
          playButtonURL={playButtonURL}
          videoURL={videoURL}
          isOpen={isOpen}
          toggleOpen={toggleOpen}
        />
        <VideoTextCtaMobile
          title={title}
          text={text}
          buttonText={buttonText}
          thumbnailURL={thumbnailURL}
          playButtonURL={playButtonURL}
          videoURL={videoURL}
          isOpen={isOpen}
          toggleOpen={toggleOpen}
        />
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { VideoTextCta }
